export default __webpack_public_path__ + "8b272a2143257f61453a9e3ad6c58338.png";